import React from "react";

import MaterialCheckbox from "../../../../../styles/materialCheckbox";
import { StyledCheckbox } from "../../../../../styles/styledTabsForm";

const CreateBalanceCheckAll = ({
  t,
  handleCheckAll,
  checked
}) => {

  return (
    <>
      <label
        className={`balances__row ${checked ? "balances_active" : ""}`}
        htmlFor={"checkAll"}
      >
        <div>
          {t("details.balancesForm.checkAll")}
        </div>
        <div>
          <StyledCheckbox position="center">
            <MaterialCheckbox
              type="checkbox"
              name="applyTo"
              id="checkAll"
              onChange={handleCheckAll}
              checked={checked}
            />
          </StyledCheckbox>
        </div>
      </label>
      <br />
    </>
  );
};

export default CreateBalanceCheckAll;